//
//
//
//
//

export default {
  name: 'FlexItem',
  props: {
    grow: {
      type: [Number, String],
      default: 0
    },
    shrink: {
      type: [Number, String],
      default: 1
    }
  },

  computed: {
    style () {
      return {
        marginLeft: `${this.$parent.num / 2}${this.$parent.unit}`,
        marginRight: `${this.$parent.num / 2}${this.$parent.unit}`
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/flexbox/FlexItem.vue